import angular from 'angular';

import EntityCategoriesEditComponent from './entity-categories-edit.component';

const EntityCategoriesEditModule = angular
    .module('control-room.commons.content.entity-categories-edit', [])
    .component('crEntityCategoriesEdit', EntityCategoriesEditComponent);

export default EntityCategoriesEditModule;
